import { TooltipWrapper } from 'components/TooltipWrapper';

interface IChoiceGroupHasTooltip {
    items: string[];
    value: string | null;
    onChange: (item: string) => void;
    getItemDisabled: (item: string) => boolean;
    tooltipMsg: string | null;
}

export const ChoiceGroupHasTooltip = (props: IChoiceGroupHasTooltip) => {
    const { items, value, onChange, getItemDisabled, tooltipMsg } = props;

    return (
        <div className="ChoiceGroup ChoiceGroup_view_ghost ChoiceGroup_size_xs ChoiceGroup_form_default ChoiceGroup_form_default">
            {items.map((item: string) => (
                <TooltipWrapper
                    key={item}
                    message={tooltipMsg}
                    size="m"
                    isInteractive={false}
                    isHidden={!getItemDisabled(item) || !tooltipMsg}
                >
                    <button
                        style={{ border: '0', fontFamily: 'var(--ag-font-family)' }}
                        disabled={getItemDisabled(item)}
                        type="button"
                        className={`ChoiceGroup-Label ${value === item && 'ChoiceGroup-Label_checked'} ${
                            getItemDisabled(item) && 'ChoiceGroup-Label_disabled'
                        }`}
                        onClick={() => onChange(item)}
                    >
                        {item}
                    </button>
                </TooltipWrapper>
            ))}
        </div>
    );
};

ChoiceGroupHasTooltip.displayName = 'ChoiceGroupHasTooltip';
